import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import SessionsList from "./pages/SessionsList";
import SessionConfirmBatches from "./pages/SessionConfirmBatches";
import SessionRecording from "./pages/SessionRecording";
import SessionResults from "./pages/SessionResults";
import Settings from "./pages/Settings";
import Roasters from "./pages/Roasters";
import "./App.css";

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          user ? (
            <Navigate to="/sessions" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route
        path="/sessions"
        element={
          <ProtectedRoute>
            <SessionsList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:sessionId/record"
        element={
          <ProtectedRoute>
            <SessionRecording />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:sessionId/confirm"
        element={
          <ProtectedRoute>
            <SessionConfirmBatches />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:sessionId/results"
        element={
          <ProtectedRoute>
            <SessionResults />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/roasters"
        element={
          <ProtectedRoute>
            <Roasters />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
